const actionTypes = {
  SET_STATUS: '@MYYOLA/STATUS/SET_STATUS',
  RESET_STATUS: '@MYYOLA/STATUS/RESET_STATUS',
};

export default actionTypes;
